import * as React from "react";
import { useTheme } from "@mui/material";

const AddPlusIcon = () => {
  const isDarkMode = useTheme().palette.mode === "dark"
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 3.75195V14.252" stroke={isDarkMode ? "var(--dark-text-primary)" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.75024 9.00024H14.2502" stroke={isDarkMode ? "var(--dark-text-primary)" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> 
    </svg>
  );
};

export default AddPlusIcon;
